import React from 'react';
import {I18n} from 'react-redux-i18n';
import {withStyles} from '@material-ui/core/styles';
import MuiExpansionPanel from '@material-ui/core/ExpansionPanel';
import MuiExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import MuiExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import IconButton from "../../../shared/components/others/IconButton";
import addButton from "../../../shared/img/add-widget-button.svg";
import deleteButton from "../../../shared/img/delete-button-chart-form.svg";
import duplicateButton from "../../../shared/img/duplicate-button.svg";
import arrowDown from "../../../shared/img/arrow-down.svg";
import SeriesLinesConfigField from "./seriesSubConfigFields/SeriesLinesConfigField";

const ExpansionPanel = withStyles({
    root: {
        backgroundColor: '#f7f7f7',
        boxShadow: 'none',
        '&:not(:last-child)': {
            borderBottom: 0,
        },
        '&:before': {
            display: 'none',
        },
        '&$expanded': {
            margin: 'auto',
        }
    },
    expanded: {},
})(MuiExpansionPanel);
const ExpansionPanelSummary = withStyles({
    root: {
        minHeight: '5rem',
        padding: '0 4rem 0 2rem'
    },
    content: {
        margin: '0 0 0 2rem',
        '&$expanded': {
            margin: '0 0 0 2rem'
        },
    },
    expanded: {},
    expandIcon: {}
})(MuiExpansionPanelSummary);
const ExpansionPanelDetails = withStyles(theme => ({
    root: {
        padding: theme.spacing(2)
    },
}))(MuiExpansionPanelDetails);

const SeriesSubConfigField =
    ({
         series = [],
         interfaceCategoryList = [],
         unitList = [],
         entityList = [],
         terminalsListByEntityId = {},
         interfacesListByEntityId = {},
         interfacesListByTerminalId = {},
         handleAddSeriesButtonClicked, //add series
         handleDeleteSeriesButtonClicked, //delete series
         handleDuplicateSeriesButtonClicked, //duplicate series
         handleSeriesFieldChange, //(seriesIndex, fieldKey, value) => "type" and "window range"
         handleAddLineToSeriesButtonClicked, //add line to series
         handleDeleteLineOfSeriesClicked, //delete line from series
         handleDuplicateLineOfSeriesClicked,
         handleLineFieldChange, //"legend", "resolution", "interfaceCategory" and "resolution agg"
         handleAddInterfaceToSeriesLineClicked, //add interface group to line
         handleDeleteInterfaceOfSeriesLineClicked, //delete interface group from line
         handleEntityChangeInSeries,
         handleTerminalChangeInSeries,
         handleInterfaceChangeInSeries,
     }) => {

        const [expandedArray, setExpanded] = React.useState(["panel_0"]);

        const handleChange = panel => (event, isExpanded) => {
            if(isExpanded) {
                setExpanded([
                    ...expandedArray,
                    panel
                ]);
            } else {
                setExpanded(expandedArray.filter( v => v !== panel));
            }
        };

        return (
            <div className="series-field-wrapper"> {/*Wrapper*/}
                {series.map((seriesElem, seriesIndex) => {
                    return (
                        <div key={"series_" + seriesIndex} className="series-element"> {/*Series Element*/}
                            <ExpansionPanel expanded={expandedArray.indexOf('panel_' + seriesIndex) !== -1 } onChange={handleChange('panel_' + seriesIndex)}>
                                <ExpansionPanelSummary
                                    id={"panel" + seriesIndex + "d-header"}
                                    aria-controls={"panel" + seriesIndex + "d-content"}
                                    expandIcon={
                                        <IconButton
                                            alt="delete"
                                            image={arrowDown}
                                            handleIconClick={() => handleChange('panel' + seriesIndex)}
                                        />
                                    }
                                >
                                    <div className="series-title">
                                        <h4 className="mb-0"><b>{I18n.t('dashboard.widgets.formsFields.chartSeries.labels.series') + " " + (seriesIndex+1)}</b></h4>
                                        <div className="series-title-action-icons">
                                            <IconButton
                                                alt="duplicate"
                                                classes={"series-title-action-icon-duplicate"}
                                                image={duplicateButton}
                                                handleIconClick={(e) => {
                                                    e.stopPropagation();
                                                    handleDuplicateSeriesButtonClicked(seriesIndex)
                                                }}
                                            />
                                            <div style={{opacity: (series.length <= 1) ? '0.5' : '1'}}>
                                                <IconButton
                                                    alt="delete"
                                                    disabled={series.length <= 1}
                                                    image={deleteButton}
                                                    handleIconClick={(e) => {
                                                        e.stopPropagation();
                                                        handleDeleteSeriesButtonClicked(seriesIndex)
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </ExpansionPanelSummary>
                                <ExpansionPanelDetails>
                                    <SeriesLinesConfigField
                                        seriesElem={seriesElem}
                                        seriesIndex={seriesIndex}
                                        interfaceCategoryList={interfaceCategoryList}
                                        unitList={unitList}
                                        entityList={entityList}
                                        terminalsListByEntityId={terminalsListByEntityId}
                                        interfacesListByEntityId={interfacesListByEntityId}
                                        interfacesListByTerminalId={interfacesListByTerminalId}
                                        handleAddInterfaceToSeriesLineClicked={handleAddInterfaceToSeriesLineClicked}
                                        handleDeleteInterfaceOfSeriesLineClicked={handleDeleteInterfaceOfSeriesLineClicked}
                                        handleEntityChangeInSeries={handleEntityChangeInSeries}
                                        handleTerminalChangeInSeries={handleTerminalChangeInSeries}
                                        handleInterfaceChangeInSeries={handleInterfaceChangeInSeries}
                                        handleSeriesFieldChange={handleSeriesFieldChange}
                                        handleAddLineToSeriesButtonClicked={handleAddLineToSeriesButtonClicked}
                                        handleDeleteLineOfSeriesClicked={handleDeleteLineOfSeriesClicked}
                                        handleDuplicateLineOfSeriesClicked={handleDuplicateLineOfSeriesClicked}
                                        handleLineFieldChange={handleLineFieldChange}
                                    />
                                </ExpansionPanelDetails>
                            </ExpansionPanel>
                        </div>
                    )
                })}

                {/*Add series element*/}
                <div className="add-series-button" onClick={handleAddSeriesButtonClicked}>
                    <IconButton
                        alt="addSeries"
                        selected={false}
                        image={addButton}
                        classes="mr-2"
                    />
                    <b>{I18n.t('dashboard.widgets.formsFields.chartSeries.labels.addSeries')}</b>
                </div>
            </div>
        );
    };

export default SeriesSubConfigField;